/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SystemFormsVersion } from '../../models/system-forms-version';

export interface SetFormVersionAsDefaultInternalV2SystemFormsFormIdVersionsVersionIdPatch$Params {
  formId: string;
  versionId: string;
  org: string;
}

export function setFormVersionAsDefaultInternalV2SystemFormsFormIdVersionsVersionIdPatch(http: HttpClient, rootUrl: string, params: SetFormVersionAsDefaultInternalV2SystemFormsFormIdVersionsVersionIdPatch$Params, context?: HttpContext): Observable<StrictHttpResponse<SystemFormsVersion>> {
  const rb = new RequestBuilder(rootUrl, setFormVersionAsDefaultInternalV2SystemFormsFormIdVersionsVersionIdPatch.PATH, 'patch');
  if (params) {
    rb.path('formId', params.formId, {});
    rb.path('versionId', params.versionId, {});
    rb.query('org', params.org, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SystemFormsVersion>;
    })
  );
}

setFormVersionAsDefaultInternalV2SystemFormsFormIdVersionsVersionIdPatch.PATH = '/_internal/v2/system-forms/{formId}/versions/{versionId}';
